import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

import { fetchAction, getAction } from '../../../ducks/actions'

import Subnav from '../../Shared/Subnav'
import Button from '../../Shared/Button'
import TabBar from '../../Shared/TabBar'
import { FullScreenLoader } from '../../Shared/Loading'

import Config from './Config'
import Logs from './Logs'

export default function ActionDetail({ match }) {
  const { id } = match.params
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchAction(id))
  }, [dispatch, id])

  const action = useSelector(getAction(match.params.id))

  if (!action) {
    return <FullScreenLoader />
  }

  const { name } = action

  const tabs = [
    {
      name: 'Logs',
      to: `/actions/${id}`,
    },
    {
      name: 'Configuration',
      to: `/actions/${id}/configuration`,
    },
  ]

  return (
    <>
      <Subnav
        title={name}
        nav={<TabBar exact tabs={tabs} />}
        actions={
          <Button to={`/actions/${id}/run`} icon="run">
            Run Action
          </Button>
        }
      />
      <Switch>
        <Route exact path="/actions/:id" component={Logs} />
        <Route path="/actions/:id/configuration" component={Config} />
      </Switch>
    </>
  )
}
